{
  "IEntity": [
    "Account",
    "Formula",
    "Palette",
    "Collaborator",
    "Folder",
    "SessionUser",
    "Team",
    "TeamInvitation",
    "Export",
    "Person"
  ],
  "IPresentationDocument": ["Presentation", "Template"],
  "IFont": ["Font", "WebFont", "FileFont"]
}
